export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";